<!--//		$only_admin = (int)Configuration::get('DLNKMESSAGES_ONLY_FOR_ADMIN');-->
<!--//		$admin_recipient_id = (int)Configuration::get('DLNK_CONTACT_MESSAGE_RECIPIENT');-->
<!--//		$is_admin = $customer->isCompanyAdmin();-->


<template>
  <div class="dlnkmessages_message_components">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkmessages-new-message
        :subject="subject"
        :reply_recipient="reply_recipient"
        :group_id="''">
    </dlnkmessages-new-message>

    <div id="dlnmessages-message-page" class="p-0">
      <!-- Tools Section -->
      <div class="position-relative bg-light">
        <div class="container space-1 space-top-lg-1 space-bottom-sm-2 space-bottom-lg-2">
          <!-- Title -->
          <div class="w-md-80 w-lg-65 text-center mx-md-auto mb-5 mb-md-4">
            <h1 class="mb-0 text-secondary">Messagerie</h1>
            <h2>
              {{ box_name }} ({{ message_count }} messages)
            </h2>

            <p v-if="box_id == 3" class="lead">
              Les messages sont définitivement supprimés au bout de 30 jours.
            </p>

          </div>
          <!-- End Title -->

          <div class="text-center mb-lg-4">

            <button type="button" class="btn btn-primary"
                    data-toggle="modal" data-target="#new_message_modal">
                        <span>
                            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp;
                            Nouveau message
                        </span>
            </button>
          </div>
        </div>

        <!-- SVG Bottom Shape -->
        <figure class="position-absolute bottom-0 right-0 left-0">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               viewBox="0 0 1920 100.1">
            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
          </svg>
        </figure>
        <!-- End SVG Bottom Shape -->
      </div>
      <!-- End Tools Section -->

      <!-- Message Section -->
      <div class="container">
        <div class="row justify-content-lg-between">

          <dlnkmessages-sidebar
              :api_url="api_url"
              :customer_id="customer_id"
              @change_box="change_box($event)">
          </dlnkmessages-sidebar>


          <div class="col-lg-8">
            <!-- Message -->

            <div v-if="message_count > 0">

              <!--              <nav aria-label="Page navigation" class="mt-2">-->
              <!--                <ul class="pagination justify-content-between align-items-center">-->
              <!--                  <li class="page-item ml-0 {if $page_number == 1}disabled{/if}">-->
              <!--                    <a class="page-link"-->
              <!--                       href="{$link->getModuleLink('dlnkmessages', 'messages', ['box' => 0, 'page_number' => $page_number - 1])|escape:'html':'UTF-8'}"-->
              <!--                       aria-label="Précédent">-->
              <!--                      <span aria-hidden="true">«&nbsp;Précédent</span>-->
              <!--                      <span class="sr-only">Précédent</span>-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                  <li class="page-item">-->
              <!--                    <div class="d-flex align-items-center">-->
              <!--                      <span class="d-none d-sm-inline-block text-body">Page TODO</span>-->
              <!--                      <span class="d-none d-sm-inline-block text-body">sur TODO</span>-->
              <!--                    </div>-->
              <!--                  </li>-->
              <!--                  <li class="page-item {if $page_number == $page_count}disabled{/if}">-->
              <!--                    <a class="page-link"-->
              <!--                       aria-label="Suivant"-->
              <!--                       href="{$link->getModuleLink('dlnkmessages', 'messages', ['box' => 0, 'page_number' => $page_number +-->
              <!--                    1])|escape:'html':'UTF-8'}">-->
              <!--                      <span aria-hidden="true">Suivant&nbsp;»</span>-->
              <!--                      <span class="sr-only">Suivant</span>-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                </ul>-->
              <!--              </nav>-->

              <article class="row pb-2 border-bottom"
                       v-for="message in messages"
                       :key="message.message_user_id">
                <div class="col">
                  <div class="card-body d-flex flex-column h-100 px-0">
                    <span class="d-block mb-2">
                      <span v-if="message.status === 'unread'"
                            class="badge badge-success badge-pill ml-1">Nouveau !</span>
                      <span class="text-primary font-weight-bold float-right">Le {{ message.created_at }}</span>
                    </span>

                    <h3>
                      <a :href="'/module/dlnkmessages/message?message_user_id=' + message.message_user_id">
                        {{ message.subject }}
                      </a>
                    </h3>

                    <div class="media align-items-center mt-auto">
                      <div class="avatar avatar-circle mr-3">

                        <img v-if="message.sender.has_photo"
                             :src="'/module/datools/getcustomerphoto?ref=' + message.sender.customer_reference"
                             class="avatar-img" :alt="'Photo de ' + message.sender.name"
                             style="width:100%; border-radius: 6px;"/>

                        <img v-else src="/themes/template/img/picto_compte/photo_manquante.jpg"
                             style="width:100%; border-radius: 6px;" class="avatar-img" alt="Photo manquante"/>

                      </div>
                      <div class="media-body">
                        <span class="text-dark">
                          <a class="d-block text-inherit font-weight-bold"
                             href="">
                            <strong>De : </strong>{{ message.sender.name }}
                          </a>
                          <!--                          <a class="d-block text-inherit font-weight-bold" href="{$ze_message->url}">-->
                          <!--                            <strong>A : </strong>{{message.receiver}}-->
                          <!--                          </a>-->
                        </span>


                        <button v-if="box_id == 3" type="button" name="restore_message" data-tooltip="tooltip"
                                @click="restore_message(message.message_user_id)"
                                title="Restaurer le message dans la boite de reception"
                                class="btn btn-sm btn-success float-right">
                          <i class="fa fa-trash-restore" aria-hidden="true"></i>
                        </button>

                        <span v-else>
                          <button type="button" name="delete_message"
                                  data-tooltip="tooltip"
                                  @click="delete_message(message.message_user_id)"
                                  title="Supprimer le message"
                                  class="btn btn-sm btn-danger float-right">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>


                        <button v-if="box_id != 2" type="button" name="reply_message"
                                data-tooltip="tooltip" title="Répondre"
                                @click="reply(message)"
                                class="btn btn-sm btn-info float-right mr-1">
                          <i class="fa fa-reply" aria-hidden="true"></i>
                        </button>

                        <button type="button" name="move_message"
                                data-tooltip="tooltip"
                                @click="open_move_popover(message.message_user_id)"
                                title="Déplacer le message"
                                class="btn btn-sm btn-info float-right mr-1">
                          <i class="fa fa-plane" aria-hidden="true"></i>
                        </button>

                        <div v-if="move_popover_open == message.message_user_id" class="move-popover is-hidden"
                             id="new_box_popover"
                             style="display: block;">

                            <div class="form-group">
                              <label>Selectionner le dossier</label>
                               <select class="form-control" id="target_box" name="target_box" v-model="new_box_id">
                                 <option v-for="box in boxes" :key="box.id" :value="box.id"  >{{ box.name }}</option>
                                </select>
                            </div>
                            <button class="btn btn-secondary" type="button"
                                    @click="close_move_popover">Annuler</button>
                            <button class="btn btn-primary" type="button" @click="move_message(message.message_user_id, new_box_id)">Valider</button>

                        </div>

                        </span>

                      </div>
                    </div>
                  </div>
                </div>
              </article>

            </div>


            <div v-else class="p-3 mt-10 mb-2 alert-info rounded">
              Cette boite de message est vide
            </div>

            <!-- End Message -->

            <!-- Sticky Block End Point -->
            <div id="stickyBlockEndPoint"></div>
          </div>

        </div>

      </div>
      <!-- End Message Section -->

    </div>
  </div>


</template>

<script>

export default {
  props: ['api_url', 'customer_id', 'param_box_id'],

  data: function () {
    return {
      message: String,
      message_type: "",
      messages: Array,
      subject: String,
      box_id: Number,
      box_name: String,
      boxes: Array,
      new_box_id: Number,
      message_count: Number,
      reply_recipient: Object,
      move_popover_open: Number,
    }
  },

  mounted() {

    this.box_id = this.param_box_id
    this.box_name = ""
    this.message_count = 0
    this.message = ""
    this.move_popover_open = false
    this.new_box_id = 0
    this.get_data()
    this.subject = ""
    this.reply_recipient = {}
  },

  methods: {

    open_move_popover: function (message_user_id) {
      this.move_popover_open = message_user_id
    },

    move_message: async function (message_user_id, new_box_id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/messages/" + message_user_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();
      form_data.append('message_user[message_box_id]', new_box_id)

      axios({
        method: 'patch',
        url: api_url,
        data: form_data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            _this.message = "Le message à été déplacé"
            _this.message_type = "alert-success"
            _this.move_popover_open = false
            _this.get_data()
          })
          .catch(function (error) {
            _this.errors = error;
            _this.message = "Une erreur est survenue. Contactez votre support"
            _this.message_type = "alert-danger"
          });
    },

    close_move_popover: function () {
      this.move_popover_open = 0
    },

    close_message: function () {
      this.message = null;
    },

    change_box: function (box_id) {
      this.box_id = box_id
      this.get_data()
    },

    delete_message: async function (message_user_id) {

      if (confirm('Êtes vous certain de vouloir supprimer ce message')) {
        const _this = this;
        let api_url = _this.api_url + "/messages/" + message_user_id + ".json"

        const secure_key = await get_token()
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + this.customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
              _this.message = "Message supprimé"
              _this.message_type = "alert-success"

            })
            .catch(function (error) {
              _this.message = "Erreur";
              _this.message_type = "alert-danger"
            })
            .then(function () {
                  // always executed
                }
            );
      }
    },

    restore_message: async function (message_user_id) {

      const _this = this;
      let api_url = _this.api_url + "/messages/" + message_user_id + ".json"

      const secure_key = await get_token()
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + this.customer_id

      const form_data = new FormData();
      form_data.append('message_user[status]', 'read');
      form_data.append('message_user[message_box_id]', 1);

      axios({
        method: 'patch',
        url: api_url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data'}
      })
          .then(function (response) {
            _this.get_data()
            _this.message = "Message restauré"
            _this.message_type = "alert-success"

          })
          .catch(function (error) {
            _this.message = "Erreur de restauration";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },

    reply: function (current_message) {

      const _this = this

      _this.subject = "RE: " + current_message.subject
      _this.reply_recipient = current_message.sender

      $('#new_message_modal').modal('toggle')
    },

    get_data: async function () {

      const _this = this;
      let api_url = _this.api_url + "/messages.json?box_id=" + _this.box_id;

      let secure_key = await get_token();
      api_url += '&secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.messages = response.data
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );

      secure_key = await get_token();
      api_url = _this.api_url + "/messages/message_count.json?box_id=" + _this.box_id;
      api_url += '&secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.message_count = response.data.message_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );

      secure_key = await get_token();
      api_url = _this.api_url + "/message_boxes/" + _this.box_id + ".json";
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.box_id = response.data.id
            _this.box_name = response.data.name
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );

      secure_key = await get_token();
      api_url = _this.api_url + "/message_boxes.json?only_move=1";
      api_url += '&secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.boxes = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>


<style scoped>

.move-popover {
  width: 320px;
  position: absolute;
  top: 3rem;
  right: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .25);
  box-shadow: 0 3px 10px rgba(0, 0, 0, .25);
  z-index: 1;
  background-color: #fff;
  padding: 1rem;
}
</style>
